/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

/*
 * Для utils.showServiceError() нужен параметр appDebug
 */
import config from './modules/env_config';
import * as AppUtils from './modules/appUtils';
window.bx24ImportLegacy = require('./modules/bx24ImoprtLegacy');

window.config = config;
window.AppUtils = AppUtils;

require('./app-bootstrap');
require('./modules/context');
require('./custom/technical-notifications');

if (isBx24Context) {
    require('./modules/bx24substitute');
    require('./modules/bx24helpers/frame');

    BX24.init(function () {
        if (!config.preserveBx24Title) {
            BX24.setTitle(appName);
        }
    });
}

// Google Analytics
if (config.gaEnable === 'true' && config.mixGaId) {
    require('./modules/ga');
} else {
    window.ga = function() { };
}
window.sendGAEvent = function (message) {
    // Чтобы не было (no set) передадим 'app' в качестве метки
    AppUtils.sendGAEvent(appContext, message, 'app');
}
window.sendGAError = function (message) {
    AppUtils.sendGAEvent(appContext, message, 'ОШИБКА');
}

window.Vue = require('vue');
// Отключение напоминания в консоли, что You are running Vue in development mode.
Vue.config.productionTip = false;
// Откючение напоминания в консоли, что Download the Vue Devtools extension
if (isDefaultContext) {
    Vue.config.devtools = !config.vueDevSaasOff;
} else {
    Vue.config.devtools = !config.vueDevFrameOff;
}

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

/**
 * Автоматическое подключение общих миксинов приложения
 */
const generalMixins = require.context('./', true, /mixins\/general\/.*\.js$/i);
generalMixins.keys().map(key => Vue.mixin(generalMixins(key).default));

/**
 * Для "ручной" регистрации vue компонентов использовать следующий пример кода:
 */

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import store from './store';
import { mapMutations } from 'vuex';

const app = new Vue({
    el: '#app',
    store,
    created() {
        let messageData = require('./config/messageBoxDefaults');
        this.setMessageBoxDefault(messageData);
    },
    methods: {
        ...mapMutations('messageBox', ['setMessageBoxDefault']),
    },
});
